import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthShell from '../components/AuthShell';
import { Button } from '../components/ui/button';
import { apiService } from '../services/api';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await apiService.forgotPassword(email.trim().toLowerCase());
      setSubmitted(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      topRightCta={{ label: 'Log in', kind: 'ghost', onClick: () => navigate('/login') }}
    >
      {submitted ? (
        <div className="auth-center">
          <h1 className="auth-heading">
            Check your <span className="auth-heading__accent">inbox</span>
          </h1>
          <p className="auth-subheading">
            If an account with that email exists, we sent a reset link. Check your inbox (and your
            spam folder).
          </p>
          <Button className="auth-btn-block" onClick={() => navigate('/login')}>
            Back to log in
          </Button>
        </div>
      ) : (
        <>
          <h1 className="auth-heading">
            Forgot <span className="auth-heading__accent">password?</span>
          </h1>
          <p className="auth-subheading">Enter your email and we'll send you a reset link.</p>

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label className="auth-label" htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="auth-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); }}
              />
            </div>

            {error && <p className="auth-error">{error}</p>}

            <div className="auth-submit">
              <Button type="submit" className="auth-btn-block" disabled={loading}>
                {loading ? 'Sending…' : 'Send reset link'}
              </Button>
            </div>
          </form>

          <p className="auth-aside">
            <button type="button" className="auth-link" onClick={() => navigate('/login')}>
              Back to log in
            </button>
          </p>
        </>
      )}
    </AuthShell>
  );
};

export default ForgotPasswordPage;
